import React, { useState, useEffect } from 'react';
import Has from '../../component/Permission/Has';
import { G_ADMIN_USER } from '../../config/PermissionTypes';

export default function FeatureFlags(props) {

    return (
        <><Has isPageLevel={true} permission={G_ADMIN_USER}>
            <div className="container-fluid feature-flags-page" data-testid="feature-flags-page">
                <div className="cb-row page-title-area">
                    <div className="cb-col-xs-8 cb-col-lg-8 page-title">
                        <h1 data-testid="add-user-page-header-title">Feature Flags</h1>
                    </div>
                </div>
            </div>
        </Has></>
    );
}